import type { Nullable } from "../../../typescript"

type NumberArray = Float32Array
| Int32Array
| Int16Array
| Int8Array
| Uint8Array
| Uint16Array
| Uint32Array
| Array<number>

export default function isNumberListSame(
  list1: Nullable<NumberArray>,
  list2: Nullable<NumberArray>,
): boolean {
  // If either array is null or they are of different lengths, return false.
  if (!list1 || !list2 || list1.length !== list2.length) {
    return false
  }

  // Check if every number in list1 matches the corresponding number in list2.
  // if the arrays are the same length but not the same list of ents,
  // then the last item is more likely to be different
  // and the first items are more likely to be the same.
  for (let i = list1.length - 1; i >= 0; i--) {
    if (list1[i] !== list2[i]) {
      return false
    }
  }
  return true
}